import React from "react";
import HOC from "../../components/HOC";
import ReturProduct from "../../components/screen/Retur/ReturProduct";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbRetur from "../../components/screen/Retur/BreadcrumbRetur";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const ReturProductPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="Retur Pembelian"
        mainComponent={
          <ThemeProvider theme={theme}>
            <ReturProduct />
          </ThemeProvider>
        }
        breadcrumb={<BreadcrumbRetur />}
        pageRole={46}
      />
    </div>
  );
};

export default HOC(ReturProductPage);
